/**
 * Check if the ota is in OTAsParity
 * @param  {object}   parity          : a parity object
 * @param  {array}    OtaIds          : array of otas (major or non-major)
 * @param  {object}   paritiesDict    : dict of parities as created in period model
 * @param  {array}  parities          : array of parities that is used to store the matching parities
 */
function parityCheck(parity, OtaIds, paritiesDict, parities, filter) {
  if (OtaIds.indexOf(parity.ota) !== -1 && filter(parity)) {
    parities.push(parity);
  }
}

/**
 * Execute a filter function for all major OTAs and return an array of matching parities
 * @param  {array}   OtaIds           : array of allowed ota ids
 * @param  {array}    paritiesDict    : dict of parities as created in period model
 * @param  {function}   filter        :  filter function
 * @param  {array}  parities          : array of (major OTA) parities that match the filter function
 */
export function filterMajorOTAs(OtaIds, paritiesDict, filter) {
  const parities = [];

  // All major otas are stored as keys on the object
  const keys = Object.keys(paritiesDict).filter((key) => key !== 'others');
  keys.forEach((key) => {
    parityCheck(paritiesDict[key], OtaIds, paritiesDict, parities, filter);
  });

  return parities;
}

/**
 * Execute a filter function for all other OTAs and return an array of matching parities
 * @param  {array}   OtaIds           : array of allowed ota ids
 * @param  {array}    paritiesDict    : dict of parities as created in period model
 * @param  {function}   filter        :  filter function
 * @param  {array}  parities          : array of (other OTA) parities that match the filter function
 */
function filterOtherOTAs(OtaIds, paritiesDict, filter) {
  const parities = [];

  paritiesDict.others.forEach((parity) => {
    // Check if the ota is in OTAsParity
    parityCheck(parity, OtaIds, paritiesDict, parities, filter);
  });

  return parities;
}

/**
 * Filter parities from a period
 * @param  {object}   paritiesDict  : dict of parities as created in period model
 * @param  {boolean}  fromMajorOtas : determines if we only want to see parities from major OTAs (checks channel)
 * @param  {array}    otas          : array of allowed otas (checks ota)
 * @param  {function} filter        : Custom additional filter function, gets passes a parity object
 * @return {array}                  : Array of relevant parities
 */
export function filterParities(
  paritiesDict,
  fromMajorOtas,
  otas,
  filter = () => true,
) {
  const OtaIds = otas.map((ota) => ota.id);

  if (fromMajorOtas) {
    return filterMajorOTAs(OtaIds, paritiesDict, filter);
  }

  return filterOtherOTAs(OtaIds, paritiesDict, filter);
}
